import React from 'react';
import { Box, Tooltip } from 'omaha-design-system';
import { useSportsbookNames } from '../hooks/useSportsbookNames';

interface SportsbookLogoProps {
  book: string;
  bookIcon?: string;
  size?: number;
  borderRadius?: string;
}

/**
 * Sportsbook logo with a Tooltip showing the DB-sourced human-readable
 * sportsbook name (falls back to the code on miss).
 */
export const SportsbookLogo: React.FC<SportsbookLogoProps> = ({
  book,
  bookIcon,
  size = 20,
  borderRadius = '4px',
}) => {
  const { getName } = useSportsbookNames();

  if (!bookIcon) return null;

  const name = getName(book);

  return (
    <Tooltip title={name} arrow>
      <Box
        component="img"
        src={bookIcon}
        alt={name}
        sx={{ width: size, height: size, borderRadius, objectFit: 'contain' }}
        onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
          e.currentTarget.style.display = 'none';
        }}
      />
    </Tooltip>
  );
};
